<template>
    <trax-ui-ajax-simple-table 
        :id="id" :header="header" :header-color="headerColor" :titles="titles"
        :endpoint="endpoint" :endpoint-params="endpointParams" :rows="rows" :cols="cols" :bus="bus">
    </trax-ui-ajax-simple-table>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-atpl-dashboard-registration-phases' },
            header: { default: 0 },
            headerColor: { default: 'info' },
            titles: null
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/registrations/' + data.registration.id,
                endpointParams: {
                    accessors: ['phases']
                },
                endpoint_states: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id,
                registration: data.registration,
                aggregation_dashboard_routes: data.aggregation_dashboard_routes,
                cols: [
                    {width: '35px'},
                    {}
                ],
                phases : null,
                states : null,
                rows: [],
                bus: new Vue()
            }
        },

        created: function() {
            this.bus.$on(this.id+'-data', this.setData);
            this.getStates();
        },
        
        updated: function() {
            $("#"+this.id+"-table .peity.donut").peity("donut");
        },
        
        methods: {
        
            getStates() {
                var that = this;
                axios.get(this.endpoint_states)
                    .then(function (response) {
                        that.setStates(response.data);
                    })
                    .catch(function (error) {
                    });
            },
            
            setData(data) {
                this.phases = data.data.phases;
                if (this.states) this.updateRows();
            },

            setStates(data) {
                this.states = data.data;
                if (this.phases) this.updateRows();
            },

            updateRows(data) {
                this.rows = [];
                for (var index in this.phases) {
                    var phase = this.phases[index];
                    this.rows.push([
                        this.num(phase, index),
                        this.name(phase),
                        this.status(phase)
                    ]);
                }
            },

            num(phase, index) {
                var html = parseInt(index)+1;
                return this.link(phase, html);
            },

            name(phase) {
                var html = phase.name;
                if (phase.custom && phase.custom.location) {
                    html += '<br><small>'+phase.custom.location.name+'</small>';
                } else if (phase.location) {
                    html += '<br><small>'+phase.location.name+'</small>';
                }
                return this.link(phase, html);
            },

            status(phase) {
                if (!this.states) return '';
                var state = this.states[phase.id];
                if (!state) return '';
                var html = '';
                html += '<span class="peity donut" data-peity=\'{ "fill": ["#00acc1", "#eeeeee"], "innerRadius": 10, "radius": 12 }\'>';
                html += state.completion.percent + '/100</span>';
                html += '<small class="ml-1">'+state.completion.percent+'%</small>';
                return this.link(phase, html);
            },

            link(phase, content) {
                var routes = this.aggregation_dashboard_routes;
                var href = routes[phase.type]+'/registration/'+this.registration.id+'/'+phase.type+'/'+phase.id;
                return '<a href="'+href+'">'+content+'</a>';
            }

        }

    }
</script>
